import React from 'react'
import { Pressable } from 'react-native'

import { buttonIcon } from '@ui-kit/components/ButtonIcon/styles'

import type { NativeProps } from './types'

const ButtonIcon = (props: NativeProps): JSX.Element => {
  const className = buttonIcon()
  return (
    <Pressable
      style={props.style}
      className={className}
      onPress={props.onPress}
      testID={props.testID}
    >
      {props.icon}
    </Pressable>
  )
}

export default ButtonIcon
